import { useContext } from 'react'

import { OffersProviderContext } from './offers-provider-context.js'

export const useOffers = () => {
  const offersContext = useContext(OffersProviderContext)

  if (!offersContext) {
    throw new Error('useOffers must be used within an OffersProvider')
  }

  return offersContext.offers
}

export const useOffer = (category: string, id: string) => {
  const offers = useOffers()

  return offers.find((offer) => offer.category === category && String(offer.id) === id)
}
